<template>
  <!-- 内容管理-结算规则 -->
  <div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="min">
          <span v-if="row.min == row.max || row.min == 0">{{ row.max }}%</span>
          <span v-else>{{ row.min }}%-{{ row.max }}%</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <span class="table-btn" @click="edit(row)">详情</span>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
  
  <script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  props: {
    query: {
      type: Object
    },
    organShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      listLoading: false,
      formData: {},
      productForm: {},
      tableData: [],
      columns: [
        {
          title: '版本号',
          key: 'versionNo',
          minWidth: 280,
          align: 'center'
        },
        {
          title: '生效时间',
          key: 'versionStartTime',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '失效时间',
          key: 'versionEndTime',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '费率区间',
          slot: 'min',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    edit(row) {
      this.$emit('callback', row);
    },
    // 设置请求方式
    setRequstType() {
      return 'GET';
    },
    getData() {
      this.initListAjax('/buz/commission/version/read/otherVersions');
    },
    // 获取列表参数
    setListParams(params) {
      params.productCode = this.query.productCode;
      params.templateId = this.query.templateId;
      if (!this.query.isTop) {
        params.organizationId = this.query.id;
      }
      if (this.userInfo.levelCode != '10001') {
        params.organizationId = this.userInfo.organId;
      }
    }
  }
};
</script>
  <style lang="scss" scoped>
</style>
  